import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,   // production auth = httpOnly session cookie set by Emergent Google Auth
});

// SECURITY NOTE — Test-only token fallback.
// In production, authentication travels via the httpOnly `session_token` cookie
// (see `withCredentials: true` above). No token is stored in localStorage on a
// real user's device.
// The block below exists ONLY so the testing agent — which seeds users via
// mongosh and cannot set httpOnly cookies from a script — can inject a bearer
// token. `getSessionTokenForTest()` reads from either sessionStorage (preferred,
// clears on tab close) or localStorage (legacy tests) and is a no-op in real
// user flows because we never write there.
/**
 * Return the session token used by the testing agent as an auth fallback.
 * @deprecated for production callers — real users authenticate via the
 *   httpOnly `session_token` cookie set by Emergent Google Auth. This helper
 *   exists ONLY so mongosh-seeded test sessions (which cannot set httpOnly
 *   cookies from Node) can attach a Bearer token to API calls.
 * @returns {string} empty string if no test token has been injected.
 */
export function getSessionTokenForTest() {
  // Hard-gate: only accept a session-storage token in dev / test builds.
  // In production the app relies on httpOnly cookies exclusively, so this
  // function is a no-op there and XSS cannot exfiltrate anything.
  if (process.env.NODE_ENV === "production") return "";
  try {
    // sessionStorage only — clears on tab close and cannot be read cross-origin.
    return sessionStorage.getItem("session_token") || "";
  } catch {
    return "";
  }
}

api.interceptors.request.use((cfg) => {
  const t = getSessionTokenForTest();
  if (t) {
    cfg.headers = cfg.headers || {};
    if (!cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    return Promise.reject(err);
  }
);

export function apiError(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}
